/**** WARNING: This is a generated file, so any changes might get overwritten! ****/
const _t = (window as any).vvTranslations?.Petitions || {};
export * from './Common.ts';
const cpr = new Intl.PluralRules(undefined);
export const Page_Header = (): string => _t.Page_Header ?? "Petitions";
export const Page_SubHeader = (): string => _t.Page_SubHeader ?? "Sign petitions to make your voice heard";
export const Active_Petitions_Header = (): string => _t.Active_Petitions_Header ?? "Active Petitions";
export const No_Petitions_Message = (): string => _t.No_Petitions_Message ?? "There are currently no active petitions.";
export const No_Petitions_Description = (): string => _t.No_Petitions_Description ?? "Check back again soon for updates!";
export const Sign_Petition_Button = (): string => _t.Sign_Petition_Button ?? "Sign Petition";
export const Signed_State_Label = (): string => _t.Signed_State_Label ?? "Signed";
export const Read_More_Button = (): string => _t.Read_More_Button ?? "Read More";
export const Read_Less_Button = (): string => _t.Read_Less_Button ?? "Read Less";
export const Petition_Text_Header = (): string => _t.Petition_Text_Header ?? "Petition Text";
export const Already_Signed_Message = (): string => _t.Already_Signed_Message ?? "You already signed this petition.";
/** Message shown when user previously signed the petition, with date */
export const Already_Signed_On_Date = (date: string): string => {
  const override: string = _t.Already_Signed_On_Date;
  const args = {date};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `You already signed this petition on ${date}.`;
  return msg;
}
;
export const Thank_You_Message = (): string => _t.Thank_You_Message ?? "Your signature has been submitted.";
export const Sign_Error_Message = (): string => _t.Sign_Error_Message ?? "There was an error signing the petition. Please try again.";
export const Back_To_Petitions_Button = (): string => _t.Back_To_Petitions_Button ?? "Back to Petitions";
export const Share_Petition_Header = (): string => _t.Share_Petition_Header ?? "Share this petition";
export const Spotlight_Label = (): string => _t.Spotlight_Label ?? "Spotlight";
export const Featured_Label = (): string => _t.Featured_Label ?? "FEATURED";
export const View_Details_Button = (): string => _t.View_Details_Button ?? "View Details";
export const Category_Label = (): string => _t.Category_Label ?? "Category";
export const Due_By_Label = (): string => _t.Due_By_Label ?? "Due by";
/** Signature count with pluralization */
export const Signatures_Label = (count: number): string => {
  const plurality = cpr.select(count);
  const override: string = _t.Signatures_Label?.[plurality];
  const args = {count};
  const msg: string =
    override ? replaceParameters(override, args) 
    : plurality === 'one' ? `${count} signature`
    : `${count} signatures`;
  return msg;
}
;
export const Loading_Message = (): string => _t.Loading_Message ?? "Loading petitions...";
export const Error_Message = (): string => _t.Error_Message ?? "Failed to load petitions";
export const Your_Information_Header = (): string => _t.Your_Information_Header ?? "Your Information";
export const Your_Information_SubHeader = (): string => _t.Your_Information_SubHeader ?? "Add your voice to this important cause";
export const Unable_To_Submit = (): string => _t.Unable_To_Submit ?? "Unable to submit";
export const Unable_To_Load_Petition = (): string => _t.Unable_To_Load_Petition ?? "Unable to load petition";
export const Invalid_Petition_Id = (): string => _t.Invalid_Petition_Id ?? "Invalid petition ID";
export const Petition_Not_Found = (): string => _t.Petition_Not_Found ?? "Petition not found";
export const No_Petition_Id_Provided = (): string => _t.No_Petition_Id_Provided ?? "No petition ID provided";
export const Failed_To_Load_Petition = (): string => _t.Failed_To_Load_Petition ?? "Failed to load petition";
export const Failed_To_Sign_Petition = (): string => _t.Failed_To_Sign_Petition ?? "Failed to sign petition. Please try again.";
export const Address_Validation_Required = (): string => _t.Address_Validation_Required ?? "Please wait for address validation to complete, or correct the address error.";
export const Thank_You_Title = (): string => _t.Thank_You_Title ?? "Success!";
export const Thank_You_Extended = (): string => _t.Thank_You_Extended ?? "Thank you for standing with us! Your voice matters in this important cause. Together, we can make a difference.";
export const Related_Petitions_Header = (): string => _t.Related_Petitions_Header ?? "Other petitions you might be interested in";
export const No_Petition_Text = (): string => _t.No_Petition_Text ?? "No petition text provided.";
export const Read_Full_Text = (): string => _t.Read_Full_Text ?? "Read full text";
export const Show_Less = (): string => _t.Show_Less ?? "Show less";
export const Days_Left = (days: string): string => {
  const override: string = _t.Days_Left;
  const args = {days};
  const msg: string =
    override ? replaceParameters(override, args) 
    : `${days}d left`;
  return msg;
}
;
